module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "account-ds"
  }, [_c('div', {
    staticClass: "bar bar-nav account-top-m"
  }, [_c('router-link', {
    staticClass: "button button-link button-nav pull-left",
    attrs: {
      "to": "/customer/account/index"
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t("message.customer_address")) + "\n                ")])], 1)]), _vm._v(" "), (_vm.errormsg) ? _c('div', {
    staticClass: "fecshop_message"
  }, [_c('div', {
    staticClass: "error-msg"
  }, [_c('div', [_vm._v("\n                    " + _vm._s(_vm.errormsg) + "\n                ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main container two-columns-left"
  }, [_c('div', {
    staticClass: "col-main account_center"
  }, [_c('div', {
    staticClass: "std"
  }, [_c('div', {
    staticStyle: {
      "margin": "4px 0 0"
    }
  }, [_c('table', {
    staticClass: "addressbook",
    attrs: {
      "width": "100%",
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "ress_tit"
  }, [_c('th', {
    attrs: {
      "width": "76",
      "valign": "middle",
      "align": "center",
      "height": "31"
    }
  }, [_vm._v(_vm._s(_vm.$t("message.name")))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "67",
      "valign": "middle",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t("message.address")))]), _vm._v(" "), _c('th', {
    staticClass: "th3",
    attrs: {
      "width": "71",
      "valign": "middle",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t("message.operation")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.addressList), function(address_item, index) {
    return _c('tr', [_c('td', {
      attrs: {
        "valign": "top",
        "align": "center"
      }
    }, [_vm._v(" " + _vm._s(address_item.first_name) + " " + _vm._s(address_item.last_name))]), _vm._v(" "), _c('td', {
      attrs: {
        "valign": "top",
        "align": "center"
      }
    }, [_vm._v("\n                                        " + _vm._s(address_item.street1) + " " + _vm._s(address_item.street2)), _c('br'), _vm._v("\n                                        " + _vm._s(address_item.city) + "\n                                        " + _vm._s(address_item.stateName) + "\n                                        " + _vm._s(address_item.countryName) + "\n                                        "), _c('br'), _vm._v(" "), (address_item.is_default == 1) ? _c('span', {
      staticStyle: {
        "color": "#cc0000"
      }
    }, [_vm._v(_vm._s(_vm.$t("message.default_address")))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "ltp",
      attrs: {
        "valign": "top ltp",
        "align": "center"
      }
    }, [_c('router-link', {
      attrs: {
        "to": '/customer/address/edit/' + address_item.address_id
      }
    }, [_c('span', {
      staticClass: "icon icon-edit"
    })]), _vm._v(" "), _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.deleteAddress(address_item.address_id)
        }
      }
    }, [_c('span', {
      staticClass: "icon icon-remove"
    })])], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "add_new_address"
  }, [_c('router-link', {
    staticClass: "button  button-light",
    attrs: {
      "to": "/customer/address/edit/new"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("message.add_new_address")) + "\n                            ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26ea6215!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/body/customer/Address.vue
// module id = 236
// module chunks = 1